import React, { PropsWithChildren } from 'react'

import { SectionProps } from '../../types/props'
import { useMediaQuery } from '@mui/material'
import './Section.scss'

export const isImageSection = (props: Partial<SectionProps>): boolean => props?.format === 'image'

export const Section = (props: PropsWithChildren<SectionProps>) => {
	const mobile = useMediaQuery('(max-width:500px)')
	const image = isImageSection(props)

	let style = {
		width: '100%',
		...props.style,
	}

	if (mobile) {
		style = {...style, ...props.mobileStyle}
	}

	const modifier = image ? 'image' : props.columns ? 'columns' : 'grid'
	const className = [
		'dm-edit-section',
		`dm-edit-section--${modifier}`,
		props?.style?.position === 'sticky' ? 'dm-edit-section--sticky' : '',
		image && props.imageWidth === 'content' ? 'dm-edit-section--image-content' : ''
	].filter(Boolean).join(' ')

	if (image) {
		// the section is nothing but an image; render nothing until one has been picked
		return <div className={className}
			style={style}>
			{ props.image?.url &&
				<img className="dm-edit-section__image"
					src={props.image.url}
					alt=""/>
			}
		</div>
	}
	
	return <div className={className}
		style={style}>
		<div className="dm-edit-section__content">
			{ props.children }
		</div>
	</div>
}

Section.craft = {
	name: 'Section'
}
